// extracted by mini-css-extract-plugin
export var searchHeader = "_8t-0";
export var searchHeaderDark = "_8t-1";